/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-env es6 */

async function getBase64ImageFromUrl(http, rainbowImage, isClient) {
  const imageUrl = rainbowImage.url.split(rainbowImage.baseUrl)[1];
  const protocol = isClient ? '' : 'https:';
  const res = await http.$get(imageUrl, { prefixUrl: `${protocol}${rainbowImage.baseUrl}`, responseType: 'blob' });

  if (isClient) {
    const blob = new Blob([res], { type: rainbowImage.type });

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.addEventListener(
        'load',
        () => {
          resolve(reader.result);
        },
        false,
      );

      reader.onerror = () => reject(imageUrl);
      reader.readAsDataURL(blob);
    });
  }

  return new Promise((resolve, reject) => {
    try {
      const result = `data:${rainbowImage.type};base64,${Buffer.from(res).toString('base64')}`;

      resolve(result);
    } catch (e) {
      reject(imageUrl);
    }
  });
}

export const state = () => ({
  obrazki: [],
});

export const getters = {
  getImage: (state) => (url) => state.obrazki.find((ob) => ob.url === url),
};

export const mutations = {
  setImage(state, image) {
    if (image && image.url && image.base64) {
      state.obrazki.push(image);
    }
  },
};

export const actions = {
  async fetchImage({ commit }, rainbowImage) {
    try {
      const image = { url: rainbowImage.url, base64: '' };
      const base64 = await getBase64ImageFromUrl(this.$http, rainbowImage, process.client);

      image.base64 = base64;
      image.url = rainbowImage.url;
      commit('setImage', image);
    } catch (err) {
      console.error(err);
    }
  },
};
